import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dateFilter from '@/filters/date';
import timeFilter from '@/filters/time';
import { jiraLink } from '@/filters/area';
import roundFilter from '@/filters/round';

import {
  Button,
  Spin,
  Table,
  Icon,
  Input,
  Tag,
  Popover,
  Checkbox,
  Row,
  Col,
  List,
  Layout,
  Card
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;

Vue.use(List);
Vue.use(Button);
Vue.use(Spin);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(Row);
Vue.use(Col);
Vue.use(Layout);
Vue.use(Card);

Vue.filter('formatDate', dateFilter);
Vue.filter('timeFilter', timeFilter);
Vue.filter('jiraLink', jiraLink);
Vue.filter('round', roundFilter);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
